import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const SECRET_KEY = 'zmTP8ai==H7Mbz:z';

@Injectable({
  providedIn: 'root',
})
export class EncryptService {
  constructor() {}

  public encrypt(data: string): string {
    return CryptoJS.AES.encrypt('' + data, SECRET_KEY).toString();
  }

  public decrypt(data: string): string {
    return CryptoJS.AES.decrypt('' + data, SECRET_KEY).toString(
      CryptoJS.enc.Utf8
    );
  }
}
